import { deepDiveApi } from '../../config/apis/deep-dive-query';
import { DashboardMonthlyRoute } from '../../config/services-route';
import { providesList } from '../../helpers/provides';
import { TagTypes } from '../types';

const dashboardApi = deepDiveApi.injectEndpoints({
  endpoints: builder => ({
    getDashboardMonthlyData: builder.query<any, any>({
      query: () => ({
        url: DashboardMonthlyRoute.getDashBoardMonthly,
        params: { _timestamp: new Date().getTime() },
      }),
      providesTags: (response: any) => {
        return providesList(response?.data, TagTypes.BarChart);
      },
    }),
    // getDashboadData: builder.query<any, any>({
    //   query: _ => {
    //     const authData = JSON.parse(localStorage?.getItem('auth') as string);

    //     return {
    //       headers: {
    //         CustomerId: authData.customer,
    //       },
    //       url: DashboardRoute.getDashBoard,
    //     };
    //   },
    //   providesTags: response =>
    //     providesList(response?.data, TagTypes.FileImport),
    // }),
  }),
});

export const { useGetDashboardMonthlyDataQuery } = dashboardApi;
